import React from 'react';
import { SpotlightOLD } from './SpotlightOLD';
import { Spotlight as SpotlightNEW } from './redesign/Spotlight';
import { SpotlightErrorBoundary } from './SpotlightErrorBoundary';

type Props = {
	isSpotlightRedesignEnabled: boolean;
};

export function Spotlight({ isSpotlightRedesignEnabled }: Props) {
	return (
		<SpotlightErrorBoundary>
			{isSpotlightRedesignEnabled ? <SpotlightNEW /> : <SpotlightOLD />}
		</SpotlightErrorBoundary>
	);
}
